/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdApplicationStoreYandexGamesRedeemYandexBonusCommand interface.
 */
export function instanceOfFxIdApplicationStoreYandexGamesRedeemYandexBonusCommand(value) {
    if (!('GameSystemName' in value) || value['GameSystemName'] === undefined)
        return false;
    if (!('YandexSecret' in value) || value['YandexSecret'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationStoreYandexGamesRedeemYandexBonusCommandFromJSON(json) {
    return FxIdApplicationStoreYandexGamesRedeemYandexBonusCommandFromJSONTyped(json, false);
}
export function FxIdApplicationStoreYandexGamesRedeemYandexBonusCommandFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'GameSystemName': json['GameSystemName'],
        'YandexSecret': json['YandexSecret'],
    };
}
export function FxIdApplicationStoreYandexGamesRedeemYandexBonusCommandToJSON(json) {
    return FxIdApplicationStoreYandexGamesRedeemYandexBonusCommandToJSONTyped(json, false);
}
export function FxIdApplicationStoreYandexGamesRedeemYandexBonusCommandToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'GameSystemName': value['GameSystemName'],
        'YandexSecret': value['YandexSecret'],
    };
}
//# sourceMappingURL=FxIdApplicationStoreYandexGamesRedeemYandexBonusCommand.js.map